<template>
  <v-container class="listContainer">
    <Loader v-if="isLoading" />
    <!-- <Empty v-else-if="Object.keys(account).length === 0 && account.constructor === Object"/> -->
    <v-card v-else-if="!isLoading">
      <v-toolbar
        dense
        light
        card
      >
        <v-toolbar-title>
          <img class="toolbarIcons" src="@/assets/img/icons/account.png" alt="account" />
          Address
          <span>
            {{ address }}
          </span>
            <img
              class="toolbarIcons copyIcon"
              src="@/assets/img/icons/copy.png"
              alt="copy"
              v-clipboard:copy="address"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            />
          </v-toolbar-title>
      </v-toolbar>
    <v-container>
    <v-list-tile class="listData">
      <v-list-tile-title class="listCategory">Total Balance</v-list-tile-title>
      <v-list-tile-content>
        {{
          account.totalBalance >= 0 ?
          account.totalBalance.toLocaleString(undefined,
          {
            minimumFractionDigits: account.totalBalance.toString().indexOf('.') > -1
            ? account.totalBalance.toString().split('.')[1].length
            : 0
          })
          : 0
        }} CMT
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile class="listData">
      <v-list-tile-title class="listCategory">Available Balance</v-list-tile-title>
            <v-list-tile-content>
        {{
          account.availableBalance >= 0
          ? account.availableBalance.toLocaleString(undefined,
          {
            minimumFractionDigits: account.availableBalance.toString().indexOf('.') > -1
            ? account.availableBalance.toString().split('.')[1].length
            : 0
          })
          : 0
        }} CMT
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile class="listData">
      <v-list-tile-title class="listCategory">Staking Amount</v-list-tile-title>
      <v-list-tile-content>
          {{
            account.currentStakeSum && account.currentStakeSum >= 0
            ? account.currentStakeSum.toLocaleString(undefined, {
            minimumFractionDigits: account.currentStakeSum.toString().indexOf('.') > -1
            ? account.currentStakeSum.toString().split('.')[1].length
            : 0
            })
            : account.stakingAmount >= 0
            ? account.stakingAmount.toLocaleString(undefined, {
            minimumFractionDigits: account.stakingAmount.toString().indexOf('.') > -1
            ? account.stakingAmount.toString().split('.')[1].length
            : 0
            })
            : 0
          }}
        </v-list-tile-content>
    </v-list-tile>
    <v-list-tile class="listData">
      <v-list-tile-title class="listCategory">Staking Reward</v-list-tile-title>
      <v-list-tile-content>
          {{
            account.stakingReward >= 0
            ? account.stakingReward.toLocaleString(undefined, {
            minimumFractionDigits: account.stakingReward.toString().indexOf('.') > -1
            ? account.stakingReward.toString().split('.')[1].length
            : 0
            })
            : 0
          }}
        </v-list-tile-content>
    </v-list-tile>
    <v-list-tile class="listData">
      <v-list-tile-title class="listCategory">Pending Unstake</v-list-tile-title>
      <v-list-tile-content>
          {{ account.pendingSum >= 0 ? account.pendingSum : 0 }}
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile class="listData">
      <v-list-tile-title class="listCategory">Transactions</v-list-tile-title>
      <v-list-tile-content>
        {{ `${totalAddressTransactions } ${totalAddressTransactions !== 1 ? "txns" :  "txn"}` }}
      </v-list-tile-content>
    </v-list-tile>

    <v-tabs
      class="tableTabs nestedTabs"
      slider-color="primary"
      v-model="activeTab"
    >
      <v-tab @click="switchTab(0)">
        {{ `${ this.totalAddressTransactions || '' } Transactions` }}
      </v-tab>
      <v-tab-item>
        <AddressTransactions
          v-if="activeTab == 0"
          v-bind:address="address"
          :isContract="false"
        />
      </v-tab-item>
      <v-tab @click="switchTab(1)">
        {{ `${ this.totalTokenTransactions || '' } CRC20 Token Txns` }}
      </v-tab>
      <v-tab-item>
        <TokenTransactions
          v-if="activeTab == 1"
          v-bind:address="address"
        />
      </v-tab-item>
      <v-tab @click="switchTab(2)">
        {{ `${ this.totalAddressTokens || '' } Token Balances ` }}
      </v-tab>
      <v-tab-item>
        <TokenBalances
          v-bind:address="address"
          v-if="activeTab == 2"
        />
      </v-tab-item>
      <v-tab @click="switchTab(3)">
        {{ `${ this.totalAddressStakes || '' } Staking Logs` }}
      </v-tab>
      <v-tab-item>
        <AddressStakes
          v-bind:address="address"
          v-if="activeTab == 3"
        />
      </v-tab-item>
      <v-tab @click="switchTab(4)">
        {{ `${ this.totalStakeRewards || '' } Reward Logs` }}
      </v-tab>
      <v-tab-item>
        <StakeRewards
          v-bind:address="address"
          v-if="activeTab == 4"
        />
      </v-tab-item>
    </v-tabs>
    </v-container>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import TokenBalances from './tokenBalances.vue';
import AddressTransactions from './addressTransactions.vue';
import TokenTransactions from './tokenTransactions.vue';
import AddressStakes from './addressStakes.vue';
import StakeRewards from './stakeRewards.vue';
import toast from '../../tools/toast';
import Loader from '../reusables/loader.vue';
import Empty from '../reusables/empty.vue';

const TabsHash = ['txs', 'token-txs', 'token-balances', 'staking-logs', 'reward-logs'];
const locHash = window.location.hash.replace('#', '');
const atIndex = TabsHash.indexOf(locHash);

export default {
  name: 'Address',
  props: ['account', 'isLoading'],
  data() {
    return {
      address: this.$route.params.address,
      activeTab: atIndex === -1 ? 0 : atIndex,
    };
  },
  created() {
    this.$store.dispatch('fetchAddressTransactions', {
      address: this.address,
      limit: 1,
      page: 1,
      onlyCount: true,
    });
  },
  computed: {
    ...mapGetters({
      totalAddressTransactions: 'totalAddressTransactions',
      totalTokenTransactions: 'totalTokenTransactions',
      totalAddressTokens: 'totalAddressTokens',
      totalAddressStakes: 'totalAddressStakes',
      totalStakeRewards: 'totalStakeRewards',
    }),
  },
  components: {
    AddressTransactions,
    Loader,
    TokenBalances,
    TokenTransactions,
    AddressStakes,
    StakeRewards,
    Empty,
  },
  watch: {
    '$route.params.address': function (newAddress) {
      this.address = newAddress;
      this.resetTotals();

      this.$store.dispatch('fetchAddressTransactions', {
        address: this.address,
        limit: 1,
        page: 1,
        onlyCount: true,
      });
    },
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab;
      this.$router.replace(`#${TabsHash[tab]}`);
    },
    onCopy(e) {
      toast.copied(`${e.text.substring(0, 10)}...`);
    },
    onError() {
      this.$notify.error({
        title: 'Error',
        message: 'Failed to copy address',
        duartion: 10,
      });
    },
    resetTotals() {
      this.$store.dispatch('resetAddressTotals');
    },
  },
  beforeDestroy() {
    this.resetTotals();
  },
};
</script>
